import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-collaboation-school-group',
  templateUrl: './collaboation-school-group.component.html',
  styleUrls: ['./collaboation-school-group.component.scss']
})
export class CollaboationSchoolGroupComponent implements OnInit {

  constructor(private router : Router) {  }

  ngOnInit(): void {
  }

   appsUrl = environment.CMS_APPS_URL;
   signUrl = environment.WEB_URL;
   searchText = '';

   searchPodcasts() {}

   viewTutorial(group, tutorial){
    this.router.navigateByUrl('/en/collaboration-school/' + group.groupId + '/' + tutorial.type);
   }

   section =  {
    "title": "Getting Started",
    "description" : "Learn the fundamentals of building a collaborative team environment.",
    "viewAllCount": 5,
    "groupId": 5,
    "cards": [
      {
        "title": "Introduction to Team Collaboration",
        "duration": "50 Minutes",
        "description": "Learn the fundamentals of building a collaborative team environment.",
        "type": "Video",
        "tag": "#Collaboration",
        "image": "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=800&q=80"
      },
      {
        "title": "Effective Communication in Remote Teams",
        "duration": "40 Minutes",
        "description": "Discover strategies to improve communication within distributed teams.",
        "type": "Read",
        "tag": "#RemoteWork",
        "image": "https://images.unsplash.com/photo-1516387938699-a93567ec168e?auto=format&fit=crop&w=800&q=80"
      },
      {
        "title": "Building a Positive Work Culture",
        "duration": "45 Minutes",
        "type": "Video",
        "description": "Explore ways to cultivate an inclusive and positive work culture.",
        "tag": "#Culture",
        "image": "https://images.unsplash.com/photo-1544531585-9847b68c8c86?auto=format&fit=crop&w=800&q=80"
      },
      {
        "title": "Time Management Techniques",
        "duration": "30 Minutes",
        "type": "Video",
        "description": "Master proven techniques to manage your time effectively.",
        "tag": "#Productivity",
        "image": "https://images.unsplash.com/photo-1434626881859-194d67b2b86f?auto=format&fit=crop&w=800&q=80"
      },
      {
        "title": "Understanding Roles and Responsibilities",
        "duration": "35 Minutes",
        "type": "Read",
        "description": "A guide to clearly defining roles and responsibilities in teams.",
        "tag": "#Management",
        "image": "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=800&q=80"
      }
    ]
  }
}
